import { tracked } from '@glimmer/tracking';

export default class Inputs {
  @tracked filterType;
  @tracked specifications;
  @tracked components;
  @tracked tolerances;
  //nextSteps;
  @tracked noise;
}
